import CreatorProfile from "./CreatorProfile";

export default function GermaniProfile() {
  return (
    <CreatorProfile
      creatorId={12}
      categoryLabel="The 'Irry' Queen"
      onlyMemberzSlug="germani"
      paywallPriceHalo={19.99}
      tags={["Action", "Blood Sistas", "Shadows & Roses", "ISM", "Collab"]}
    />
  );
}
